// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"606":"60965daa","712":"6a612c50","719":"01052858","755":"279183f1"}[chunkId] + ".chunk.js";
};